export const empty = {
  value: '',
  label: '',
};
